import { getFullPath, routes } from "../routes";
import { Navigate, useParams } from "react-router-dom";
import { TestEventForm } from "./form";
import { useTestEvent } from "./hooks";

export function EditTestEvent() {
  const { id } = useParams();
  const { data, isLoading, isError } = useTestEvent(id);

  if (isLoading) {
    return <p>Loading...</p>;
  } else if (isError) {
    return <p>An unknown error occurred.</p>;
  } else if (data) {
    return <TestEventForm data={data} />;
  } else {
    return <Navigate to={getFullPath(routes.testEvent.create)} />;
  }
}
